import { useState, useCallback, useRef, useEffect } from "react";

export function useScrollFade(direction = "vertical", deps = []) {
  const [faded, setFaded] = useState(false);
  const elRef = useRef(null);
  const roRef = useRef(null);

  const check = useCallback(() => {
    const el = elRef.current;
    if (!el) return;

    if (direction === "vertical") {
      const hasOverflow = el.scrollHeight > el.clientHeight;
      const atEnd = el.scrollTop + el.clientHeight >= el.scrollHeight - 2;
      setFaded(hasOverflow && !atEnd);
    } else {
      const hasOverflow = el.scrollWidth > el.clientWidth;
      const atEnd = el.scrollLeft + el.clientWidth >= el.scrollWidth - 2;
      setFaded(hasOverflow && !atEnd);
    }
  }, [direction]);

  const callbackRef = useCallback(
    (node) => {
      // cleanup previous element
      const prev = elRef.current;
      if (prev) {
        prev.removeEventListener("scroll", check);
        roRef.current?.disconnect();
      }

      elRef.current = node;

      if (node) {
        check();
        node.addEventListener("scroll", check, { passive: true });
        const ro = new ResizeObserver(check);
        ro.observe(node);
        roRef.current = ro;
      }
    },
    [check],
  );

  useEffect(() => {
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, [check]);

  // re-check when deps change
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(check, [check, ...deps]);

  return [callbackRef, faded];
}
